function approveUser(userId) {
    if (!userId) {
        alert('Ошибка: не указан ID пользователя');
        return;
    }

    const approveUrl = `/godmode/api/user/${userId}/approve/`;
    
    fetch(approveUrl, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(res => res.json())
    .then(data => {
        if (data && data.success) {
            alert(data.message || 'Пользователь успешно одобрен');
            location.reload();
        } else if (data && data.error) {
            alert('Ошибка: ' + data.error);
        } else if (data && data.title) {
            alert('Ошибка: ' + data.title);
        } else {
            alert('Произошла неизвестная ошибка');
        }
    })
    .catch(error => {
        console.error('Error approving user:', error);
        alert('Произошла ошибка при одобрении пользователя');
    });
}

function rejectUser(userId) {
    if (!userId) {
        alert('Ошибка: не указан ID пользователя');
        return;
    }

    const rejectUrl = `/godmode/api/user/${userId}/reject/`;
    
    fetch(rejectUrl, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            reason: 'intro'
        }),
    })
    .then(res => res.json())
    .then(data => {
        if (data && data.success) {
            alert(data.message || 'Пользователь успешно отклонен');
            location.reload();
        } else if (data && data.error) {
            alert('Ошибка: ' + data.error);
        } else if (data && data.title) {
            alert('Ошибка: ' + data.title);
        } else {
            alert('Произошла неизвестная ошибка');
        }
    })
    .catch(error => {
        console.error('Error rejecting user:', error);
        alert('Произошла ошибка при отклонении пользователя');
    });
}

window.approveUser = approveUser;
window.rejectUser = rejectUser;
